import React, { useEffect, useRef } from 'react';

const SERVICES = [
  {
    icon: '🌐',
    title: 'Website Design & Build',
    desc: 'A clean, modern website built from scratch — mobile-friendly, fast, and ready to represent your business from day one.',
  },
  {
    icon: '🔍',
    title: 'SEO Basics',
    desc: "Getting your site found on Google. I'll set up proper page titles, descriptions, keywords, and local SEO so customers in your area can find you.",
  },
  {
    icon: '📍',
    title: 'Google Business Profile',
    desc: "Setting up and optimizing your Google Business listing so you show up on Maps, get reviews, and look legit when someone searches your name.",
  },
  {
    icon: '⚡',
    title: 'Speed & Performance',
    desc: "Slow sites lose customers. I'll optimize images, clean up the code, and make sure your site loads fast on phones and desktops alike.",
  },
  {
    icon: '🔧',
    title: 'Ongoing Maintenance',
    desc: 'Need something updated, added, or fixed? I offer simple monthly maintenance so your site never goes stale or breaks without you knowing.',
  },
  {
    icon: '📬',
    title: 'Contact Forms & Lead Capture',
    desc: "Add a contact form, quote request, or email signup so visitors can reach you directly — and you never miss a potential customer.",
  },
  {
    icon: '🚀',
    title: 'Fast Turnaround',
    desc: "Most sites are live within a few days. No long timelines, no waiting around — just tell me what you need and I'll get it done.",
  },
];

const Services = () => {
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('visible');
      }),
      { threshold: 0.1 }
    );
    const els = revealRefs.current;
    els.forEach((el) => el && observer.observe(el));
    return () => els.forEach((el) => el && observer.unobserve(el));
  }, []);

  const ref = (i) => (el) => { revealRefs.current[i] = el; };

  return (
    <section id="services" className="section services-section">
      <div className="section-header reveal" ref={ref(0)}>
        <span className="section-num">02.</span>
        <h2 className="section-title">What I Can Do For You</h2>
        <div className="section-line" />
      </div>

      <div className="services-grid">
        {SERVICES.map((s, i) => (
          <div
            key={s.title}
            className={`service-card reveal reveal-delay-${i % 3}`}
            ref={ref(i + 1)}
          >
            <span className="service-icon">{s.icon}</span>
            <h3 className="service-title">{s.title}</h3>
            <p className="service-desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
